// /* eslint-disable */
// import React from 'react';
// import { Pie } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
// } from 'chart.js';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const LegalPieChart = ({ filedBy, filedAgainst, entityName }) => {
//   const data = {
//     labels: [`Filed by ${entityName}`, `Filed against ${entityName}`],
//     datasets: [
//       {
//         data: [filedBy, filedAgainst],
//         backgroundColor: ['#2b5797', '#c9def4'],
//         borderColor: '#ffffff',
//         borderWidth: 2,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: true,
//     plugins: {
//       datalabels: {
//         color: "white",
//         anchor: "center",
//         align: "center",
//         font: {
//           weight: "bold",
//           size: 14,
//         },
//       },
//       legend: {
//         display: true,
//         position: 'bottom',
//         labels: {
//           usePointStyle: true,
//           pointStyle: 'rectRounded',
//           color: '#000',
//           font: {
//             family: 'sans-serif',
//             size: 12,
//           },
//         },
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `${context.label}: ${context.raw}`;
//           },
//         },
//       },
//     },
//   };

//   return (
//     <div style={{ width: '100%', maxWidth: '302px', height: '300px', margin: '0 auto', position: 'relative'}}>
//       <Pie data={data} options={options} />
//     </div>
//   );
// };

// export default LegalPieChart;

// ############### New code ###################
// /* eslint-disable */
// import React from 'react';
// import { Pie } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
// } from 'chart.js';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const LegalPieCharts = ({ oppositionBreakup = [] }) => {
//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: true,
//         position: 'bottom',
//         labels: {
//           usePointStyle: true,
//           pointStyle: 'rectRounded',
//           color: '#000',
//           font: {
//             family: 'sans-serif',
//             size: 12,
//           },
//         },
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `${context.label}: ${context.raw}`;
//           },
//         },
//       },
//     },
//   };

//   return (
//     <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", justifyContent: "center" }}>
//       {(oppositionBreakup || []).map((item, index) => {
//         const data = {
//           labels: [`Filed by ${item.entity}`, `Filed against ${item.entity}`],
//           datasets: [
//             {
//               data: [item.filed_by_tml, item.filed_against_tml],
//               backgroundColor: ['#2b5797', '#c9def4'],
//               borderColor: '#ffffff',
//               borderWidth: 2,
//             },
//           ],
//         };

//         return (
//           <div key={index} style={{ width: "300px", height: "300px" }}>
//             <h4 style={{ textAlign: "center", fontSize: "14px", marginBottom: "10px" }}>
//               {item.entity}
//             </h4>
//             <Pie data={data} options={chartOptions} />
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default LegalPieCharts;


// ########### new code single ##############
/* eslint-disable */
import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const LegalPieChartCombined = ({ oppositionBreakup = [] }) => {
  // Flatten data into labels + values
  const labels = [];
  const values = [];
  const backgroundColors = [];

  const colorPalette = [
    "#2b5797", "#c9def4", "#f4a261", "#2a9d8f", "#e76f51", 
    "#8ab6d6", "#e9c46a", "#264653", "#a8dadc", "#ffb4a2"
  ];

  let colorIndex = 0;

  // oppositionBreakup.forEach(item => {
  //   labels.push(`Filed by ${item.entity}`);
  //   values.push(item.filed_by_tml);
  //   backgroundColors.push(colorPalette[colorIndex % colorPalette.length]);
  //   colorIndex++;

  //   labels.push(`Filed against ${item.entity}`);
  //   values.push(item.filed_against_tml);
  //   backgroundColors.push(colorPalette[colorIndex % colorPalette.length]);
  //   colorIndex++;
  // });

  const dataArray = Array.isArray(oppositionBreakup)
  ? oppositionBreakup
  : oppositionBreakup
  ? [oppositionBreakup]
  : [];

  dataArray.forEach(item => {
    if (item.filed_by_tml > 0) {
      labels.push(`Filed by ${item.entity}`);
      values.push(item.filed_by_tml);
      backgroundColors.push(colorPalette[colorIndex % colorPalette.length]);
      colorIndex++;
    }

    if (item.filed_against_tml > 0) {
      labels.push(`Filed against ${item.entity}`);
      values.push(item.filed_against_tml);
      backgroundColors.push(colorPalette[colorIndex % colorPalette.length]);
      colorIndex++;
    }
  });



  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: backgroundColors,
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: false,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        color: "white",
        anchor: "center",
        align: "center",
        font: {
          weight: "bold",
          size: 14,
        },
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: "400px", height: "400px", marginLeft:"20px", marginTop:"20px"}}>
      <Pie data={data} options={options} width={300} height={300} />
    </div>
  );
};

export default LegalPieChartCombined;

